//Dependencies............................................
import React from "react";
import {Button, Form, Input, Modal} from 'antd';

//Components..............................................
import {User} from "utils/interfaces";
import { Control, Controller, FieldErrors, SubmitHandler, UseFormHandleSubmit } from "react-hook-form";

interface Props {
    showEditUserModal: boolean,
    toggleEditUserModal: () => void,
    userEditErrors: FieldErrors<User>,
    userEditControl: Control<User, any, User>,
    onSubmit: SubmitHandler<User>,
    userEditHandleSubmit: UseFormHandleSubmit<User, User>,
    selectedUser: User | null,
    isValid: boolean,
    isDirty: boolean,
    isSubmitting: boolean,
}



const EditUserModal: React.FC<Props> = ({
    showEditUserModal,
    toggleEditUserModal,
    userEditErrors,
    userEditControl,
    userEditHandleSubmit,
    onSubmit,
    selectedUser,
    isValid,
    isDirty,
    isSubmitting
}: Props) => {

    return(
        <Modal
            open={showEditUserModal}
            onCancel={toggleEditUserModal}
            title={`Editing access for ${selectedUser?.user_email}`}
            closable={!isSubmitting}
            mask={{ closable: !isSubmitting }}
            footer={[
                <Button type="default" onClick={toggleEditUserModal} disabled={isSubmitting}>Close</Button>,
                <Button
                    type="primary"
                    onClick={userEditHandleSubmit(onSubmit)}
                    disabled={!isValid || !isDirty || isSubmitting}
                    loading={isSubmitting}
                >Save Changes</Button>
            ]}
        >
            <Form layout="vertical" preserve={false}>
                <Form.Item
                    label="User Email"
                    validateStatus={userEditErrors.user_email ? "error" : ""}
                    help={userEditErrors.user_email?.message}
                >
                    <Controller
                        name="user_email"
                        control={userEditControl}
                        rules={{ required: "Email is required" }}
                        render={({field}) => (
                            <Input
                                {...field}
                                placeholder="Enter user email"
                            />
                        )}
                    />
                </Form.Item>
            </Form>
        </Modal>
    )
}

export default EditUserModal;